import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {Text} from '@/components/ui/text/Text'
import {StyledPrintSiarCategoryRadioField} from '@/features/projects/components/print-siar-form/print-siar-sections-selector/style'
import {PrintSiarFormSchema} from '@/features/projects/formSchemas'
import {siarSections} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {ObjectEntries} from '@/utilities/helpers'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const PrintSiarSectionsSelectorSchema = PrintSiarFormSchema.pick({
    categorySection: true
})
type PrintSiarSectionsSelectorSchema = z.infer<typeof PrintSiarSectionsSelectorSchema>

export const PrintSiarSectionsSelector = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<PrintSiarSectionsSelectorSchema>()
    const {field: categorySectionField} = useController({control, name: 'categorySection'})

    return (
        <>
            {ObjectEntries(siarSections).map(([key, {title, sections}]) => (
                <Flexbox direction="column" key={key} fullWidth gap={3}>
                    <StyledPrintSiarCategoryRadioField
                        label={t(title)}
                        value={key}
                        checked={categorySectionField.value == key}
                        onChange={() => categorySectionField.onChange(key)}
                    />
                    <FormCardSection columns={1} gap={2} padding={2} fullWidth>
                        {sections.map(section => (
                            <Flexbox key={section.value} direction="column">
                                <Text size="textSm" weight="500">
                                    {t(section.title)}
                                </Text>
                                <Text size="textSm" palette="neutral" shade="600">
                                    {t(section.description)}
                                </Text>
                            </Flexbox>
                        ))}
                    </FormCardSection>
                </Flexbox>
            ))}
        </>
    )
}
